import { FilterAlt } from '@mui/icons-material';
import { Button, Drawer, Grid, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

import { DrawerHeader } from './components/DrawerHeader';

export interface FilterType {
  name: string;
  value: string;
  label: string;
}

interface MobileFilterProps {
  onApply: (filters: {
    title?: string;
    host?: string;
    enrolled?: boolean;
    showMine?: boolean;
    showAll?: boolean;
  }) => void;
  filterConfig?: React.ReactNode | undefined;
  sortConfig?: React.ReactNode | undefined;
}

enum ToggleButtonProps {
  enrolled = 'enrolled',
  showAll = 'showAll',
  showMine = 'showMine'
}

export const MobileFilter = ({ onApply, filterConfig, sortConfig }: MobileFilterProps) => {
  const { t } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [titleSearchInput, setTitleSearchInput] = useState<string | undefined>(undefined);
  const [hostSearchInput, setHostSearchInput] = useState<string | undefined>(undefined);
  const [toggleButtonValue, setToggleButtonValue] = useState<ToggleButtonProps[]>([]);

  function createToggleObject(
    array: ToggleButtonProps[]
  ): Record<ToggleButtonProps, boolean | undefined> {
    const toggleObject: Record<ToggleButtonProps, boolean | undefined> = {
      [ToggleButtonProps.enrolled]: undefined,
      [ToggleButtonProps.showAll]: undefined,
      [ToggleButtonProps.showMine]: undefined
    };

    array.forEach(prop => {
      toggleObject[prop] = true;
    });

    return toggleObject;
  }

  const handleFilterDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleFormat = (event: React.MouseEvent<HTMLElement>, newFormats: ToggleButtonProps[]) => {
    setToggleButtonValue(newFormats);
  };

  const handleFilterApply = () => {
    setDrawerOpen(false);
    onApply({
      title: titleSearchInput,
      host: hostSearchInput,
      ...createToggleObject(toggleButtonValue)
    });
  };

  const renderFilters = filterConfig => {
    return (
      <Grid container alignItems={'center'} justifyContent={'center'} gap={2}>
        <TextField
          value={titleSearchInput}
          onChange={event => setTitleSearchInput(event.target.value)}
          label={t(translations.common.title())}
          variant="outlined"
          fullWidth
        />
        <TextField
          value={hostSearchInput}
          onChange={event => setHostSearchInput(event.target.value)}
          label={t(translations.pages.events.filter.host())}
          variant="outlined"
          fullWidth
        />
        <ToggleButtonGroup value={toggleButtonValue} onChange={handleFormat} fullWidth>
          <ToggleButton value={'enrolled'}>
            {t(translations.pages.events.filter.enrolled())}
          </ToggleButton>
          <ToggleButton value={'showAll'}>
            {t(translations.pages.events.filter.showAllMobile())}
          </ToggleButton>
          <ToggleButton value={'showMine'}>
            {t(translations.pages.events.filter.myEventsMobile())}
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
    );
  };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            padding: 2,
            gap: 2
          }
        }}
      >
        <DrawerHeader onClose={() => setDrawerOpen(false)} />
        {renderFilters(filterConfig)}
        <Button
          variant="contained"
          style={{ margin: 10, marginTop: 80 }}
          onClick={handleFilterApply}
          startIcon={<FilterAlt />}
        >
          {t(translations.common.apply())}
        </Button>
      </Drawer>
      <Button
        variant="contained"
        style={{
          position: 'fixed',
          bottom: 30,
          left: '50%',
          transform: 'translateX(-50%)',
          minWidth: 160,
          zIndex: 10
        }}
        onClick={handleFilterDrawerOpen}
        startIcon={<FilterAlt />}
      >
        {t(translations.common.filter())}
      </Button>
      {/* <Grid container alignItems={'center'} justifyContent={'flex-end'} flexWrap={'nowrap'}>
        <Grid item>{sortConfig}</Grid>
      </Grid> */}
    </>
  );
};
